import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import '../save-scenario-dialog.scss';

export interface SimpleDialogProps {
  open: boolean;
  onClose: any;
  updateScenarioData: any;
}

export interface ScenarioInfo {
  scenarioName: boolean;
}

function OverrideNameDialog(props: SimpleDialogProps) {
  const { onClose, open, updateScenarioData } = props;

  const handleCloseDialog = () => {
    onClose();
  };

  const updateScenario = () => {
    updateScenarioData();
  };

  return (
    <Dialog open={open} onClose={handleCloseDialog}>
      <DialogTitle>
        Override Scenario
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <p className='override-message'>
        Scenario Name already exists. Do you want to override it?
      </p>
      <DialogActions>
        <Button variant='outlined' onClick={handleCloseDialog}>
          Cancel
        </Button>
        <Button variant='contained' onClick={updateScenario}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default OverrideNameDialog;
